function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { BrevoNamedLogo, BrevoIconAloneLogo, BrevoPlusLogo, BrevoPlusLightLogo, WonderPushNamedLogo146X36 } from './logoSvgs';
import moduleStyles from '@dtsl/css-logo/dist/index.module.css';
import OrganisationLogo from '@dtsl/icons/dist/icons/react/Organisation';
function Logo(props) {
  const {
    to = '#',
    logo = 'default',
    target = '_self',
    onClick = () => {},
    ariaLabel = '',
    color = null,
    clickable = true,
    className = '',
    style: svgStyles = {},
    ...restProps
  } = props;
  const logoWrapperClasses = classNames({
    [moduleStyles['sib-logo']]: true,
    [moduleStyles[logo]]: !!logo,
    [className]: !!className
  });
  const logoClasses = classNames({
    [moduleStyles['sib-logo__clickable']]: clickable,
    [moduleStyles[[`${logo}--svg`]]]: !!logo,
    [className]: !clickable && !!className
  });
  const logoComponents = {
    sib: /*#__PURE__*/React.createElement(OrganisationLogo, {
      height: "100%",
      width: "100%"
    }),
    default: /*#__PURE__*/React.createElement(BrevoNamedLogo, null),
    'icon-alone': /*#__PURE__*/React.createElement(BrevoIconAloneLogo, null),
    brevoplus: /*#__PURE__*/React.createElement(BrevoPlusLogo, null),
    'brevoplus-light': /*#__PURE__*/React.createElement(BrevoPlusLightLogo, null),
    wonderpush: /*#__PURE__*/React.createElement(WonderPushNamedLogo146X36, null)
  };
  const getLogoColor = color ?? (logo === 'sib' ? 'hsla(206, 100%, 50%, 1)' : logo === 'wonderpush' ? 'var(--brand-charcoal-grey-900)' : 'var(--brand-forest-green-600)');
  const getLogo = logo => {
    const logoComponent = logoComponents[logo] || logoComponents['default'];
    return /*#__PURE__*/React.cloneElement(logoComponent, {
      color: getLogoColor,
      onClick: !clickable ? handleClick : () => {},
      className: logoClasses
    });
  };
  const handleClick = e => {
    if (to === '#' && clickable) {
      e.preventDefault();
      e.nativeEvent.stopImmediatePropagation();
    }
    onClick(e);
  };
  return clickable ? /*#__PURE__*/React.createElement("a", _extends({
    href: to,
    target: target,
    onClick: handleClick,
    "aria-label": ariaLabel ? ariaLabel : logo === 'sib' ? 'Sendinblue' : logo === 'wonderpush' ? 'WonderPush' : 'Brevo',
    className: logoWrapperClasses,
    rel: "noreferrer",
    style: {
      color: getLogoColor
    }
  }, restProps), /*#__PURE__*/React.createElement("span", {
    style: {
      ...svgStyles
    }
  }, getLogo(logo))) : /*#__PURE__*/React.createElement("span", {
    className: logoWrapperClasses
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      ...svgStyles
    }
  }, getLogo(logo)));
}
Logo.propTypes = {
  color: PropTypes.string,
  logo: PropTypes.oneOf(['sib', 'icon-alone', 'default', 'brevoplus', 'brevoplus-light', 'wonderpush']),
  clickable: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  to: PropTypes.string,
  target: PropTypes.string,
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func
};
export default Logo;